import * as React from 'react'
import {ReactElement, ReactNode} from 'react'
import styled from 'styled-components'
import {Colors} from '../../styledComponents/Constants'
import {Nullable} from '../../app/TypeHelpers'
import {ADMINISTORATOR_MODE} from '../../CodeMaster'
import EventEmitterExAdmin from '../shared/pageBaseComponents/EventEmitterExAdmin'
import NatMenuMasterRepo from '../../__NoAutomatedTests/components/menuMaster/repository/NatMenuMasterRepo'
import {Box, ClickAwayListener} from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import {LoginUserInfo} from './AdminHeaderAreaComponent'
import {FlexGrowContent, RowFlexContainer} from '../../styledComponents/FlexComponents'
import {AdminDefaultButton} from '../../styledComponents/adminPage/Buttons'
import NatAdminMenuMasterComponentSp
    from '../../__NoAutomatedTests/components/menuMaster/admin/NatAdminMenuMasterComponentSp'
import {AsyncCommunicationProps, withAsyncCommunication} from '../shared/hoc/withAsyncCommunication'
import {
    ADMIN_HEADER_HEIGHT,
    AdminHeaderArea,
    AdminHeaderLogo,
    AdminHeaderShadow,
    AdminHeaderShadowCss,
    ChangeModeButtons,
    ChangeModePanelButton,
    ManualLink,
    MenuPanelButton,
    PanelContainer,
    ResidentlLink,
    SelectedModeInfo,
    UserInfo,
    UserInfoPanelButton,
    ViewingCondominium,
    ViewingCondominiumGroup,
} from './AdminHeaderAreaParts'
import {RouterPageProps} from '../shared/RouterPropsInjector'

interface Props {
    loginedFlg: boolean
    menuMasterRepo: NatMenuMasterRepo
    eventEmitter: EventEmitterExAdmin

    mode: Nullable<string>
    selectedCondominiumName: Nullable<string>
    hasValidSubCondominiumGroup: boolean
    loginUserInfo: LoginUserInfo

    handleClickAllMode: () => void
    handleClickCondominiumMode: () => void
    handleLogoutClick: () => void
    handleClickCondominiumGroupSwitchingLink: () => void
    handleChangeLoginSiteToResidentButtonClick: () => void
}

interface States {
    openedPanel: 'mode' | 'user' | 'menu' | false
}

class AdminHeaderAreaComponentSp extends React.Component<Props & AsyncCommunicationProps & RouterPageProps, States> {
    constructor(props: Props & AsyncCommunicationProps & RouterPageProps) {
        super(props)

        this.state = {
            openedPanel: false,
        }
    }

    closePanel = () => {
        this.setState({openedPanel: false})
    }

    changeOpenedPanel = (panel: 'mode' | 'user' | 'menu') => {
        if (this.state.openedPanel === panel) {
            this.closePanel()
        } else {
            this.setState({openedPanel: panel})
        }
    }

    handleClickChangeModePanelButton = () => {
        this.changeOpenedPanel('mode')
    }

    handleClickAllMode = () => {
        this.closePanel()
        this.props.handleClickAllMode()
    }

    handleClickCondominiumMode = () => {
        this.closePanel()
        this.props.handleClickCondominiumMode()
    }

    handleClickCondominiumGroupSwitchingLink = () => {
        this.closePanel()
        this.props.handleClickCondominiumGroupSwitchingLink()
    }

    handleClickUserInfoPanelButton = () => {
        this.changeOpenedPanel('user')
    }

    handleChangeLoginSiteToResidentButtonClick = () => {
        this.closePanel()
        this.props.handleChangeLoginSiteToResidentButtonClick()
    }

    handleClickMenuPanelButton = () => {
        this.changeOpenedPanel('menu')
    }

    handleClickLogout = () => {
        this.closePanel()
        this.props.handleLogoutClick()
    }

    renderChangeModePanel(): ReactNode {
        if (!this.props.loginUserInfo.isBelongCondominiumGroup) {
            return null
        }

        const {openedPanel} = this.state
        const isOpen = openedPanel === 'mode'

        return <>
            <PanelContainer $panelOpened={isOpen}>
                <ChangeModePanelButton
                    panelOpened={isOpen}
                    onClick={this.handleClickChangeModePanelButton}
                />
                <Panel $open={isOpen} id={'panel-mode'}>
                    <PanelContent $maxWidth={'432px'}>
                        <ChangeModeButtons
                            allMode={this.props.mode === ADMINISTORATOR_MODE.ALL.value}
                            handleClickAllMode={this.handleClickAllMode}
                            handleClickCondominiumMode={this.handleClickCondominiumMode}
                        />
                        <ViewingCondominiumGroup
                            loginUserCondominiumGroupName={this.props.loginUserInfo.loginUserCondominiumGroupName}
                            hasValidSubCondominiumGroup={this.props.hasValidSubCondominiumGroup}
                            handleClickCondominiumGroupSwitchingLink=
                                {this.handleClickCondominiumGroupSwitchingLink}
                        />
                        {this.props.mode === ADMINISTORATOR_MODE.CONDOMINIUM.value &&
                        <ViewingCondominium
                            selectedCondominiumName={this.props.selectedCondominiumName}
                            handleClickCondominiumSwitchingLink={this.handleClickCondominiumMode}
                        />
                        }
                    </PanelContent>
                </Panel>
            </PanelContainer>
        </>
    }

    // ユーザ情報
    renderUserInfoPanel(): ReactNode {
        const {roleName, loginUserAdminFamilyName, loginUserAdminFirstName} = this.props.loginUserInfo
        const {openedPanel} = this.state
        const isOpen = openedPanel === 'user'

        return <>
            <PanelContainer $panelOpened={isOpen}>
                <UserInfoPanelButton
                    panelOpened={isOpen}
                    onClick={this.handleClickUserInfoPanelButton}
                />
                <Panel $open={isOpen} id={'panel-user'}>
                    <PanelContent $maxWidth={'376px'}>
                        <UserInfo
                            roleName={roleName}
                            loginUserAdminFamilyName={loginUserAdminFamilyName}
                            loginUserAdminFirstName={loginUserAdminFirstName}
                        />
                        <ManualLink roleId={this.props.loginUserInfo.roleId}/>
                        <ResidentlLink
                            handleChangeLoginSiteToResidentButtonClick=
                                {this.handleChangeLoginSiteToResidentButtonClick}
                        />
                        <LogoutButton onClick={this.handleClickLogout}>
                            ログアウト
                        </LogoutButton>
                    </PanelContent>
                </Panel>
            </PanelContainer>
        </>
    }

    renderMenuPanel(): ReactNode {
        const {openedPanel} = this.state
        const isOpen = openedPanel === 'menu'

        return <>
            <PanelContainer $panelOpened={isOpen}>
                <MenuPanelButton
                    panelOpened={isOpen}
                    onClick={this.handleClickMenuPanelButton}
                />
                <Panel $open={isOpen}>
                    <MenuContainer>
                        <NatAdminMenuMasterComponentSp
                            {...this.props}
                            close={this.closePanel}
                            opened={isOpen}
                        />
                    </MenuContainer>
                </Panel>
            </PanelContainer>
        </>
    }

    // 共通フレームスマホ対応メニュー
    renderHeaderPanels(): ReactNode {
        const {openedPanel} = this.state
        return <>
            <ClickAwayListener
                onClickAway={this.closePanel}
                mouseEvent={openedPanel ? undefined : false}
                touchEvent={openedPanel ? undefined : false}
            >
                <RowFlexContainer>
                    {this.renderChangeModePanel()}
                    {this.renderUserInfoPanel()}
                    {this.renderMenuPanel()}
                </RowFlexContainer>
            </ClickAwayListener>
        </>
    }

    renderSelectedModeInfo(): ReactNode {
        const {loginUserCondominiumGroupName, isBelongCondominiumGroup} = this.props.loginUserInfo
        const allMode = this.props.mode === ADMINISTORATOR_MODE.ALL.value

        return <>
            <SelectedModeInfoArea $height={isBelongCondominiumGroup ? '56px' : '44px'}>
                <SelectedModeInfo
                    loginUserCondominiumGroupName={loginUserCondominiumGroupName}
                    selectedCondominiumName={this.props.selectedCondominiumName}
                    allMode={allMode}
                    spMode={true}
                    isBelongCondominiumGroup={isBelongCondominiumGroup}
                />
            </SelectedModeInfoArea>
        </>
    }

    render(): ReactElement {
        const {loginedFlg} = this.props

        return <>
            <AdminHeaderShadow>
                <AdminHeaderArea>
                    <Box width={'8px'}/>
                    <AdminHeaderLogo/>
                    <FlexGrowContent/>
                    {loginedFlg && this.renderHeaderPanels()}
                </AdminHeaderArea>
            </AdminHeaderShadow>

            {loginedFlg && this.renderSelectedModeInfo()}
        </>
    }
}

const Panel = styled.div<{ $open: boolean }>`

  position: absolute;
  top: ${ADMIN_HEADER_HEIGHT}px;
  right: 0;
  background-color: ${Colors.Surface};
  color: ${Colors.Body};
  ${AdminHeaderShadowCss};
  z-index: -1;

  transform-origin: top;
  transition: all 0.25s;
  ${props => props.$open ? `
    transform:scale(1,1);
    opacity: 1;
  ` : `
    transform:scale(1,0);
    opacity: 0;
  `}
`

const MenuContainer = styled.div`
  width: 90vw;
  max-width: 400px;
`

const PanelContent = styled.div<{ $maxWidth: string }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  word-break: break-all;
  width: 100vw;
  max-width: ${props => props.$maxWidth};
  padding: 25px 15px;
`

const SelectedModeInfoArea = styled.div<{ $height: string }>`
  display: flex;
  align-items: center;
  background-color: ${Colors.Surface};
  width: 100%;
  height: ${props => props.$height};
  padding: 0 8px;
`

const LogoutButton = withStyles({
    root: {
        width: '100%',
    },
})(AdminDefaultButton)

export default withAsyncCommunication(AdminHeaderAreaComponentSp)
